import Button from "comps/Button"
import { cls } from "reactutils"

type SearchFooterProps = {
  onReset: () => void
  onConfirm: () => void
}

export default function SearchFooter({
  onConfirm,
  onReset,
}: SearchFooterProps) {
  return (
    <>
      <div className="footerWrap">
        <Button
          text="重置"
          type="secondary"
          onClick={onReset}
          className={cls("footerBtn", "resetBtn")}
        />
        <Button
          onClick={onConfirm}
          className={"footerBtn"}
          type="primary"
          text="确认"
        />
      </div>
      <style jsx>{`
        .footerWrap {
          flex: 0 0 56px;
          background: #ffffff;
          box-shadow: 0 -2px 4px 0 rgba(0, 0, 0, 0.07);
          text-align: center;
          padding-top: 7px;
          box-sizing: border-box;
          display: flex;
          flex-direction: row;
          justify-content: center;
        }

        .footerWrap :global(.footerBtn) {
          margin-right: 20px;
          width: 136px;
          display: inline-block;
          vertical-align: middle;
          height: 44px;
          line-height: 44px;
        }

        .footerWrap :global(.footerBtn:last-child) {
          margin-right: 0;
        }

        .resetBtn {
          border-color: rgba(0, 0, 0, 0.3);
          color: #2e2d37;
        }
      `}</style>
    </>
  )
}
